import { useNavigate } from 'react-router-dom';
import { AdminShell } from './AdminShell.jsx';
import { useTenantAdminAuth } from '../../auth/TenantAdminAuthContext.jsx';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: 'grid', end: true },
  { to: '/menus', label: 'Menus', icon: 'menu' },
  { to: '/media', label: 'Media', icon: 'image' },
  { to: '/settings/security', label: 'Security', icon: 'shield' },
];

export function TenantAdminShell() {
  const { identity, logout } = useTenantAdminAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return <AdminShell brand="Restaurant Admin" navItems={NAV_ITEMS} onLogout={handleLogout} identityLabel={identity?.email} />;
}
